import { render } from "./BuyUnits.vue?vue&type=template&id=84d1f29c&scoped=true"
import script from "./BuyUnits.vue?vue&type=script&lang=js"
export * from "./BuyUnits.vue?vue&type=script&lang=js"

import "./BuyUnits.vue?vue&type=style&index=0&id=84d1f29c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d1f29c"]])

export default __exports__